import { Context, createContext, Dispatch, SetStateAction, useState } from 'react'
import { AppProps } from './AppProps'

declare type theme = 'light' | 'dark'
declare type ThemeContextType = Context<{
    theme: theme
    setTheme: Dispatch<SetStateAction<theme>>
}>
const THEME_KEY = 'theme'

export function initializeTheme() {
    if (getTheme() === 'dark') {
        document.documentElement.classList.add('dark')
    } else {
        document.documentElement.classList.remove('dark')
    }
}

export function setUserTheme(theme: theme) {
    localStorage.setItem(THEME_KEY, theme)
    initializeTheme()
}

export function getTheme(): theme {
    return getUserTheme() ?? getBrowserTheme()
}

export function getUserTheme(): theme | null {
    const storageTheme = localStorage.getItem(THEME_KEY)
    if (storageTheme === 'dark' || storageTheme === 'light') {
        return storageTheme
    }
    return null
}

export function getBrowserTheme(): theme {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

export function resetUserTheme() {
    localStorage.removeItem('theme')
}

export const ThemeContext: ThemeContextType = createContext({
    theme: getTheme(),
    setTheme: (action: SetStateAction<theme>) => {},
})

export function ThemeWrapper({ children }: AppProps): JSX.Element {
    const [theme, setTheme] = useState(getTheme())
    return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>
}
